import React from "react";
import "quill/dist/quill.snow.css";

/**
 * Quill 2 + react-quill-new default to getSemanticHTML(), which encodes every
 * ASCII space as &nbsp; (see quill/core/editor.js convertHTML). That inflates
 * stored HTML; use root.innerHTML instead via useSemanticHTML={false}.
 */
export const ReactQuillWrapper = React.lazy(async () => {
  const rq = await import("react-quill-new");
  const ReactQuill = rq.default;
  const { Quill } = ReactQuill;
  const Block = Quill.import("blots/block") as any;
  const ListItem = Quill.import("formats/list") as any;
  const Header = Quill.import("formats/header") as any;

  class CustomList extends ListItem {
    static create(value: any) {
      const node = super.create(value);
      node.setAttribute("class", "customFormatList");
      return node;
    }
  }

  class CustomHeader extends Header {
    static create(value: any) {
      const node = super.create(value);
      node.setAttribute("class", "customFormatHeader-" + value);
      return node;
    }
  }

  class CustomBlock extends Block {
    static create(value: any) {
      let node = super.create();
      node.setAttribute("class", "customFormatBlock");
      return node;
    }
  }

  const SizeStyle = Quill.import("attributors/style/size") as any;
  SizeStyle.whitelist = ["10px", "14px", "18px", "22px", "32px", "54px"];
  Quill.register(SizeStyle, true);

  CustomBlock.tagName = "p";
  Quill.register(CustomBlock);
  Quill.register(CustomList);
  Quill.register(CustomHeader);

  const Editor: React.FC<React.ComponentProps<typeof ReactQuill>> = (props) => (
    <ReactQuill useSemanticHTML={false} {...props} />
  );

  return { default: Editor };
});
